﻿export * from './rest.component';
